<script>
  import OverlayDrawerArtworks from "./overlay-drawer-artworks.vue";
  import OverlayDrawerImage from "./overlay-drawer-image.vue";
  import OverlayDrawerStatusBlock from "./overlay-drawer-status-block.vue";
  import OverlayDrawerArtists from "./overlay-drawer-artists.vue";
  import { addSvgToEnd } from "Helpers/embedSVG";

  export default {
    components: {
    OverlayDrawerImage,
    OverlayDrawerStatusBlock,
    OverlayDrawerArtworks,
    OverlayDrawerArtists,
},
    props: {
      overlayData: {
        type: Object,
        required: true,
      },
      galleryWorks: {
        type: Array,
        required: true
      },
      artists: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        linkText: 'Learn more',
      };
    },
    computed: {
      showStatusBlock() {
        return this.overlayData.status || this.overlayData.throughDate;
      },
      linkTextHTML() {
        return addSvgToEnd(this.overlayData.linkText, '$typography/size:medium typography','icon__arrow--16--stroke.svg', 'typography/icon:after');
      },
      showOverlayImage() {
        return this.overlayData.imageURL && !this.overlayData.isGallery;
      },
      showArtWorks() {
        return this.overlayData.isGallery && this.galleryWorks?.length > 0;
      },
      showArtists() {
        return this.overlayData.isGallery && this.artists?.length > 0;
      },
    },
  };
</script>

<template>
  <div
    class="
      @600/layout/width:max
      layout/grid
      layout/width:100%
    "
    style="
      --600--layout--width--max: calc(var(--page-width--maximum) / 3);
    "
    >
    <div
      class="
        layout/padding:left:page
        layout/padding:right:page
      "
      >
      <p
        v-if="overlayData.location"
        class="
          $color/gray:767
          $typography/size:medium
          color
          typography
        "
        v-html="overlayData.location"
        />
      <h1
        v-if="overlayData.title"
        class="
          $typography/size:medium-large
          layout/margin:top:cap
          layout/padding:right:page:0.5
          typography
        "
        v-html="overlayData.title"
      />
      <OverlayDrawerStatusBlock
        v-if="showStatusBlock"
        :overlay-data="overlayData"
      />
      <p
        v-if="overlayData.description"
        class="
          $typography/baseline:body
          $typography/size:medium
          $typography/weight:regular
          layout/margin:top:page
          typography
        "
        v-html="overlayData.description"
        />
      <OverlayDrawerImage
        v-if="showOverlayImage"
        :overlay-data="overlayData"
      />
    </div>
    <div
      v-if="showArtWorks"
      class="
        layout/margin:top:page:2
        layout/margin:bottom:page
      "
      >
      <OverlayDrawerArtworks :artworks="galleryWorks" />
    </div>
    <div
      v-if="showArtists"
      class="
        layout/margin:top:page
        layout/margin:bottom:page"
      >
      <OverlayDrawerArtists
        :artists="artists"
        :gallery-id="overlayData.id"
      />
  </div>
    <div
      v-if="overlayData.mdeLink"
      class="
        layout/margin:top:page
        layout/padding:left:page
        layout/padding:right:page
      "
      >
      <a
        :href="overlayData.mdeLink"
        v-html="linkTextHTML"
      />
    </div>
  </div>
</template>